import React, { Component, useEffect } from "react";
import { connect } from "react-redux";
import { phoneIconChange } from "../../Images/Images";
import iconUnifiedMedia from '../../Images/WorkBar/icon-unified-media.svg'
import iconChat from '../../Images/WorkBar/icon-chat.svg'
import iconHistoryNotAvailable from '../../Images/WorkBar/icon-history-not-available.svg'
import iconCallHistory from '../../Images/WorkBar/icon-call-history.svg'
import iconNotAvailable from '../../Images/WorkBar/icon-not-available.svg'
import iconManualDial from '../../Images/WorkBar/icon-manual-dial.svg'
import iconManualWhatsapp from '../../Images/WorkBar/icon-whatsapp.svg'
import iconLocalLogs from '../../Images/WorkBar/icon-agent-log.svg'
import { USER_STATE } from '../../constants';
import { visibleWindow } from "../../redux/actions/A_window_visible500";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { WINDOW_AT_500, DRAGGABLE_WINDOWS, INTEGRATION, ACTIONS_FROM_SM } from "../../constants";
import { insertWindow, removeWindow } from "../../redux/actions/A_draggable_windows_controller";
import { manualCallWindow, callRecord, supervisorChatFloating, noAvailableRecordDrag, noAvailableFloating } from "../../js/draggableComponents";
import { SingletonSharedData } from "../../js/singletonSharedData";
import { Singleton } from "../../js/Singleton";
import { showUnifiedMessagesWindow } from '../../redux/actions/A_actions_UnifiedInbox'
import { OTHER_ACTIONS, ACTIONS_INTEGRATION } from "../../constants";
import { setCurrentPosition, getCurrentPosition, getCurrentSize, getParameters, getTableOptions, getTotalSelected } from "../../js/Singletons/RecordCallSingleton.js";
import { changeStateMultimedia, changeStateMultimediaAll } from '../../redux/actions/A_messages_to_SM';

class WorkBar extends Component {
  constructor(props) {
    super(props);
    this.timmerAnimationChat = null;
    this.timmerShowMessage = null;
    this.timmerRemoveWindow = null;
    this.sharedData = new SingletonSharedData();
    this.state = {
      showMessage: true,
      numberChats: 0,
      onBigAnimationChat: false
    };
    this.chatOpen = false;
    this.integrationAction = null;
    this.integrationData = null;
    this.actionTypeIntegration = null;
    this.language = new Singleton();
  }

  shouldComponentUpdate(nextProps, nexState) {
    if (
      (nextProps.stateMachineActions.actionType === ACTIONS_FROM_SM.MESSAGE_FROM_SUPERVISOR && !this.sharedData.getChatWindowOpen())
      || (
        nextProps.messagesIntegrations && nextProps.messagesIntegrations.actionType !== ACTIONS_INTEGRATION.NONE
        && nextProps.messagesIntegrations.dataMessageIntegration
      )
      || (nextProps.otherActions.action === OTHER_ACTIONS.DELETE_CHAT_NOTIFICATIONS && this.state.numberChats === 0)
      || this.state.numberChats !== nexState.numberChats
      || nextProps.showUnifiedMessages !== this.props.showUnifiedMessages
      || this.props.userState.currentState !== nextProps.userState.currentState
      || this.props.dialingMode !== nextProps.dialingMode
    ) {
      return true;
    }
    return false;
  }

  componentWillReceiveProps(nextProps) {
    let _this = this;

    if (!this.sharedData.getChatWindowOpen() && nextProps.stateMachineActions.actionType === ACTIONS_FROM_SM.MESSAGE_FROM_SUPERVISOR) {
      this.setState({ numberChats: ++this.state.numberChats, onBigAnimationChat: true });
      this.timmerAnimationChat = setTimeout(() => { this.setState({ onBigAnimationChat: false }); }, 1000);
    }

    this.timmerShowMessage = setTimeout(() => {
      _this.props.visibleWindow(!_this.sharedData.isInCallState() ? WINDOW_AT_500.CALL : WINDOW_AT_500.NONE);
      if (!_this.state.showMessage) {
        _this.setState({ showMessage: true });
      }
    }, 100);

    if (nextProps.messagesIntegrations && nextProps.messagesIntegrations.actionType !== ACTIONS_INTEGRATION.NONE && nextProps.messagesIntegrations.dataMessageIntegration) {
      if (nextProps.messagesIntegrations.dataMessageIntegration.action === INTEGRATION.OPEN_WINDOW) {
        this.actionTypeIntegration = INTEGRATION.OPEN_WINDOW;
        this.openFromIntegration(nextProps.messagesIntegrations.dataMessageIntegration.window);
      } else if (nextProps.messagesIntegrations.dataMessageIntegration.action === INTEGRATION.MANUAL_CALL) {
        this.integrationData = {
          campaingID: nextProps.messagesIntegrations.dataMessageIntegration.camId,
          phoneNumber: nextProps.messagesIntegrations.dataMessageIntegration.phoneNumber,
          callKey: nextProps.messagesIntegrations.dataMessageIntegration.callKey,
          data1: nextProps.messagesIntegrations.dataMessageIntegration.clientName,
          recievedAlert: false
        };
        this.actionTypeIntegration = INTEGRATION.MANUAL_CALL;
        this.openFromIntegration(INTEGRATION.MAKE_CALL);
      }
    }
    if (
      nextProps.otherActions.action === OTHER_ACTIONS.DELETE_CHAT_NOTIFICATIONS &&
      nextProps.otherActions !== this.props.otherActions
    ) {
      this.setState({ numberChats: 0 });
    }
    if (nextProps.keyPressed) {
      this.handleKeyPress(nextProps.keyPressed);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timmerAnimationChat);
    clearTimeout(this.timmerShowMessage);
    clearTimeout(this.timmerRemoveWindow);
  }

  openFromIntegration(window) {
    switch (window) {
      case "MakeCall":
        this.sharedData.setIsIntegration();
        let props = null;
        if (this.integrationData) {
          props = {
            action: INTEGRATION.MANUAL_CALL,
            callData: this.integrationData
          };
        }
        this.manualCall(props, false);
        break;
      case "ManualCall":
        this.sharedData.setIsIntegration();
        this.manualCall(undefined, false);
        break;
      case "AgentChat":
        if (this.sharedData.getWindowExpandedActive() !== DRAGGABLE_WINDOWS.SUPERVISOR_CHAT ) {
          this.agentChat();
        } else {
          this.agentChat();
          setTimeout(() => {
            this.agentChat();
          }, 1);
        }
        break;
      case "CallRecord":
        this.callRecord(false);
        break;
      default:
        break;
    }
  }
  normalAgentChatAction = (closedIfOpen = true) => {
    this.props.insertWindow(supervisorChatFloating({regsMultiple:this.props.previewSimultaneousRecs}), closedIfOpen);
    this.setState({ numberChats: 0 });
    this.sharedData.setChatWindowOpen(!this.sharedData.getChatWindowOpen());
  }
  normalNoAvailableAction = (closedIfOpen = true) => {
    this.props.insertWindow(noAvailableFloating({regsMultiple:this.props.previewSimultaneousRecs}), closedIfOpen);
  }
  normalNoAvailableRecordAction = (closedIfOpen = true) => {
    this.props.insertWindow(noAvailableRecordDrag({regsMultiple:this.props.previewSimultaneousRecs}), closedIfOpen);
  }
  expandedComponent(tagComponent, normalAction) {
    if (window.innerWidth > 1300 && !this.props.previewSimultaneousRecs) {
      if (this.sharedData.getStateWindow(tagComponent)) {
        //ESTA ABIERTO
        if (this.sharedData.getWindowExpandedActive() === tagComponent) {
          //ES LA VENTANA ACTIVA, SE CIERRA
          this.props.removeWindow(tagComponent);
          this.sharedData.setStateWindow(tagComponent, false);
          this.sharedData.setChatWindowOpen(false);
        } else {
          this.sharedData.setWindowExpandedActive(tagComponent);
          normalAction(false);
          this.sharedData.setStateWindow(tagComponent, true);
        }
      } else {
        //SE ABRIRA LA VENTANA
        this.sharedData.setWindowExpandedActive(tagComponent);
        const toclose = this.sharedData.getExpandedWindowsToClose(tagComponent);
        this.timmerRemoveWindow = setTimeout(() => { this.props.removeWindow(toclose); }, 20);
        var _this = this;
        toclose.forEach(function (window) {
          _this.sharedData.setStateWindow(window, false);
        });
        normalAction(false);
        this.sharedData.setStateWindow(tagComponent, true);
      }
    } else {
      if (this.sharedData.getStateWindow(tagComponent)) {
        //ESTA ABIERTA, CERRAR
        this.props.removeWindow(tagComponent);
        this.sharedData.setStateWindow(tagComponent, false);
        this.sharedData.setChatWindowOpen(false);
      } else {
        //CERRADA, ABRIR
        this.sharedData.setWindowExpandedActive(tagComponent);
        normalAction(false);
        this.sharedData.setStateWindow(tagComponent);
      }
    }
  }

  agentChat = () => {
    this.expandedComponent(DRAGGABLE_WINDOWS.SUPERVISOR_CHAT, closeIfOpen =>
      this.normalAgentChatAction(closeIfOpen)
    );
    
  }

  notAvailable = () => {
    this.expandedComponent(DRAGGABLE_WINDOWS.NO_AVAILABLE, closeIfOpen =>
      this.normalNoAvailableAction(closeIfOpen)
    );
  }
  notAvailableRecord = () => {
    this.expandedComponent(DRAGGABLE_WINDOWS.NO_AVAILABLE_RECORD, closeIfOpen =>
      this.normalNoAvailableRecordAction(closeIfOpen)
    );
  }

  manualCall(props = null, closedIfOpen = true, isManualMessage) {
    this.sharedData.phoneNumber = '';
    this.props.insertWindow(manualCallWindow(props, isManualMessage), closedIfOpen);
  }

  callRecord = (closedIfOpen = true) => {
    let props = {
      dragFunc: dragEvent =>
        setCurrentPosition({
          xPosition: dragEvent.movementX,
          yPosition: dragEvent.movementY
        }),
      position: getCurrentPosition(),
      sizeWindow: getCurrentSize(),
      paramsCell: getParameters(),
      tableOptions: getTableOptions(),
      totalSelected: getTotalSelected()
    };
    this.props.insertWindow(callRecord(props), closedIfOpen);
  }

  showMessageUnified() {
    if (!this.sharedData.isInCallState()) {
      if (this.state.showMessage) {
        this.props.visibleWindow(WINDOW_AT_500.MESSAGE);
      } else {
        this.props.visibleWindow(WINDOW_AT_500.CALL);
      }
      this.setState({ showMessage: !this.state.showMessage });
    } else {
      this.props.visibleWindow(WINDOW_AT_500.MESSAGE);
      this.setState({ showMessage: true });
    }
  }

  handleKeyPress(key) {
    var state = this.sharedData.getCurrentState();
    if (state !== "firstCall") {
      switch (key) {
        case "N": //Open unavailable window
        case "U":
          if (state !== "NotReady")
            this.expandedComponent(
              DRAGGABLE_WINDOWS.NO_AVAILABLE,
              this.normalNoAvailableAction
            );
          break;
        case "T": //Focus cursor in phone field (Manual call Window)
        case "P":
          if (this.sharedData.getStateWindow(DRAGGABLE_WINDOWS.MANUAL_CALL)) {
            this.sharedData.setFocusTel(true);
            this.manualCall(null, false);
          }
          break;
        case "C": //Open chat with supervisor          
          if (state !== "NotReady")
            this.expandedComponent(
              DRAGGABLE_WINDOWS.SUPERVISOR_CHAT,
              this.normalAgentChatAction
            );
          break;
        case "M": //Open manual call window
          this.manualCall(null, false);
          break;
        case "H": //Open unavailable history window
          if (state !== "NotReady")
            this.expandedComponent(
              DRAGGABLE_WINDOWS.NO_AVAILABLE_RECORD,
              this.normalNoAvailableRecordAction
            );
          break;
        case "L": //Open open call history window
          this.callRecord(false);
          break;
        default:
          break;
      }
    }
  };

  onClickbuttonWorkBarContainer = () => {
    this.props.showUnifiedMessages ? this.props.showUnifiedMessagesWindow(false) : this.props.showUnifiedMessagesWindow(true);
    this.props.showUnifiedMessages ? this.sharedData.setIsTabFocused(false) : this.sharedData.setIsTabFocused(true);
    if (this.props.userState.currentState === USER_STATE.DIALOG_WHATSAPP) {
      const data = this.props.selectedData;
      data.onReady = true;
      this.props.onChangeState(data);
    }
    if (this.props.userState.currentState === USER_STATE.DIALOG_EMAIL) {
      const data = this.props.selectedData;
      data.onReady = true;
      this.props.onChangeStateUnified(data);
    }
  }
  downloadLogs() {
    const ts = new Date();
    const logKey = `LOG-${ts.getDate()}-${ts.getMonth() + 1}-${ts.getFullYear()}`
    const currentLog = window.localStorage.getItem(logKey).replaceAll(';', '\n');
    const element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(currentLog));
    element.setAttribute('download', logKey);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  render() { 
    const inactiveMode = this.sharedData.getIsInactiveState();
    return (
      <div className="workBarSide">
        {this.sharedData.generalPermissions[220] === '1' && !this.sharedData.isInCallState(this.props.userState.currentState) &&
          <OverlayTrigger
            key="tlt-mensajeria"
            id="tlt-mensajeria"
            placement="right"
            overlay={<Tooltip id="tooltip-tlt-mensajeria" className={"workbar-tooltip show"}> {this.props.showUnifiedMessages ? this.language.getText("GUIWorkBarMainMenu") : this.language.getText("GUIWorkBarMessages")} </Tooltip>}
          >
            <div className={`buttonWorkBarContainer  ${this.sharedData.hasUnifiedMessage ? 'newMessage ' : ''} ${inactiveMode ? 'disabled' : ''}`}
              onClick={this.onClickbuttonWorkBarContainer}
            >
              <img src={this.props.showUnifiedMessages ? phoneIconChange : iconUnifiedMedia}
                className={`buttonWorkBar ${this.props.showUnifiedMessages ? 'show-phone' : 'show-media'}`} alt="Mensajeria"
              />
            </div>
          </OverlayTrigger>}
        <OverlayTrigger
          key="tlt-chat-agente"
          id="tlt-chat-agente"
          placement="right"
          overlay={
            <Tooltip id="tooltip-tlt-chat-agente" className="workbar-tooltip show">{this.language.getText("GUIWorkBarAgentChat")}</Tooltip>
          }
        >
          <div className={`buttonWorkBarContainer ${inactiveMode ? 'disabled' : ''}`} onClick={this.agentChat}        >
            <img src={iconChat} className={"buttonWorkBar " + (this.state.onBigAnimationChat ? "bigChatanimation " : "") + (this.props.userState.currentState === USER_STATE.NO_AVAILABLE ? "onTop" : "")} alt="Chat Agente" />
            {this.state.numberChats > 0 && (
              <p className={"numberChatNotification " + (this.state.onBigAnimationChat ? "bigChatanimation " : "") + (this.props.userState.currentState === USER_STATE.NO_AVAILABLE ? "onTop" : "")}              >
                {this.state.numberChats}
              </p>
            )}
          </div>
        </OverlayTrigger>
        <OverlayTrigger
          key="tlt-no-disponible"
          id="tlt-no-disponible"
          placement="right"
          overlay={
            <Tooltip id="tooltip-tlt-no-disponible" className="workbar-tooltip show">{this.language.getText("GUIWorkBarUnavailable")}</Tooltip>
          }
        >
          <div className={`buttonWorkBarContainer ${inactiveMode ? 'disabled' : ''}`} onClick={this.notAvailable}        >
            <img src={iconNotAvailable} className="buttonWorkBar" alt="No Disponible" />
          </div>
        </OverlayTrigger>
        {this.props.dialingMode === 0 && <OverlayTrigger
          key="tlt-marcaciones-manuales"
          id="tlt-marcaciones-manuales"
          placement="right"
          overlay={
            <Tooltip className="workbar-tooltip show" id="tooltipId-tlt-marcaciones-manuales">{this.language.getText("GUIWorkBarManualCall")}</Tooltip>
          }
        >
       <div className={`buttonWorkBarContainer ${inactiveMode ? 'disabled' : ''}`} onClick={() => this.manualCall()}        >
            <img src={iconManualDial} className={"buttonWorkBar " + (this.props.userState.currentState === USER_STATE.NO_AVAILABLE ? "onTop" : "")} alt="Marcacion Manual" />
          </div>
        </OverlayTrigger>}

        {this.props.dialingMode === 0 && <OverlayTrigger
          key="tlt-mensajes-manuales"
          id="tlt-mensajes-manuales"
          placement="right"
          overlay={
            <Tooltip className="workbar-tooltip show" id="tooltipId-tlt-mensajes-manuales">{this.language.getText("GUIWorkBarManualMessage")}</Tooltip> //TODO: Falta poner etiqueta
          }
        >
       <div className={`buttonWorkBarContainer ${inactiveMode || this.props.userState.currentState !== USER_STATE.AGENT_READY ? 'disabled' : ''}`} onClick={() => this.manualCall(null, true, true)}        >
            <img src={iconManualWhatsapp} className={"buttonWorkBar " + (this.props.userState.currentState !== USER_STATE.AGENT_READY ? "" : "onTop")} alt="Mensajeria Manual" width={40} />
          </div>
        </OverlayTrigger>}

        <OverlayTrigger
          key="tlt-no-disponibles"
          id="tlt-no-disponibles"
          placement="right"
          overlay={
            <Tooltip className="workbar-tooltip show" id="tooltipId-tlt-no-disponibles">{this.language.getText("GUIWorkBarUnavailableHistory")}</Tooltip>
          }
        >
          <div className={`buttonWorkBarContainer ${inactiveMode ? 'disabled' : ''}`} onClick={this.notAvailableRecord}  >
            <img src={iconHistoryNotAvailable} className="buttonWorkBar" alt="Historial No Disponible" />
          </div>
        </OverlayTrigger>
        <OverlayTrigger
          key="tlt-historial"
          id="tlt-historial"
          placement="right"

          overlay={
            <Tooltip className="workbar-tooltip show" id="tooltipId-tlt-historial">{this.language.getText("GUIWorkBarCallHistory")}</Tooltip>
          }
        >
          <div className={`buttonWorkBarContainer ${inactiveMode ? 'disabled' : ''}`} onClick={this.callRecord}          >
            <img src={iconCallHistory} className={"buttonWorkBar " + (this.props.userState.currentState === USER_STATE.NO_AVAILABLE ? "onTop" : "")} alt="Historial llamadas" />
          </div>
        </OverlayTrigger>
        {this.props.enableLocalLog && <OverlayTrigger
          key="tlt-locallog"
          id="tlt-locallog"
          placement="right"
          overlay={
            <Tooltip className="workbar-tooltip show" id="tooltipId-tlt-locallog">{'Download local logs'}</Tooltip>
          }
        >
          <div className={`buttonWorkBarContainer ${inactiveMode ? 'disabled' : ''}`} onClick={this.downloadLogs}          >
            <img src={iconLocalLogs} className="buttonWorkBar" alt="Local Logs" />
          </div>
        </OverlayTrigger>}
      </div>
        );
  }
}

function mapStateToProps(state) {
  return {
    stateMachineActions: state.stateMachineActions,
    userState: state.userState,
    messagesIntegrations: state.messagesIntegrations,
    otherActions: state.otherActions,
    showUnifiedMessages: state.unifiedInboxState.show,
    enableLocalLog: state.localLogState.enableLocalLog,
    selectedData: state.unifiedInboxState.selectedData,
    dialingMode: state.preview.dialingMode,
    previewSimultaneousRecs: state.preview.simultaneosRecs
  };
}

function mapDispatchToProps(dispatch) {
  return {
    visibleWindow: windowVisible => {
      dispatch(visibleWindow(windowVisible));
    },
    insertWindow: (dragWindow, closeComponentIfOpen) => {
      dispatch(insertWindow(dragWindow, closeComponentIfOpen));
    },
    removeWindow: iDdragComponents => {
      dispatch(removeWindow(iDdragComponents));
    },
    showUnifiedMessagesWindow: show => {
      dispatch(showUnifiedMessagesWindow(show))
    },
    onChangeState: data => {
      dispatch(changeStateMultimedia(data))
    },
    onChangeStateUnified: data => {
      dispatch(changeStateMultimediaAll(data))
    }
  };
}

export default WorkBar = connect(mapStateToProps, mapDispatchToProps)(WorkBar);



// WEBPACK FOOTER //
// ./src/components/workSpace/workBar.jsx